"use client";

import MainLandingPage from "../../components/landing/MainLandingPage";

export default function HomePageClient() {
  return <MainLandingPage />;
}
